module.exports = __webpack_public_path__ + "img/water-droplet-4.932dba88.png";